import { gateway } from "../../../../../../gateway";
import { EJobStatuses } from "../../../../enum/job.enums";

export interface IJobEvent {
  startDate?: Date;
  endDate?: Date;
  status?: EJobStatuses;
  eventUid?: any;
  duration?: number;
}

const startDateFromArrivalWindow = (slot?: { date?: string; start?: string }) => {
  if (!slot?.date || !slot?.start) return undefined;
  return `${slot.date}T${slot.start}:00`;
};

export const updateJobEvent = async (schedulerPayload: any, jobEventUid: string) => {
  const preferences = schedulerPayload?.eventPreferences;
  const startDate = preferences?.fixedTimes?.[0] || startDateFromArrivalWindow(preferences?.bufferedTimes?.[0]);
  const endDate = preferences?.eventConfig?.endDate;
  const duration = preferences?.eventConfig?.duration;

  const body: IJobEvent = {
    startDate: startDate || undefined,
    endDate: endDate || undefined,
    status: EJobStatuses.SCHEDULED,
    duration,
  };

  try {
    const response = await gateway.patch(`/jobs/event/${jobEventUid}`, body);
    return response.data.data;
  } catch (error) {
    console.error("Error to update job event", error);
    throw error;
  }
};
